
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';


export const ImageZoom = ({ imageUrl }) => {
	return (
		<Zoom>
			<img
				alt="Comprobante de pago"
				src={imageUrl}
				className="max-w-full h-auto max-h-[70vh] w-auto rounded-lg object-contain cursor-zoom-in"
				loading="eager"
				decoding="async"
			/>
		</Zoom>
	);
};
